export default {"src":"/_next/static/media/delete.2de8a139.svg","height":12,"width":9};